import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';

/**
 * HomeRedirect:
 * A component that redirects users to their appropriate dashboard based on their role
 * when they land on the root path (/).
 */
export const HomeRedirect: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { isAuthenticated, user, _hasHydrated } = useAuthStore();

    if (!_hasHydrated) {
        // Show a loading state while we rehydrate the auth state
        return (
            <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center">
                <div className="w-10 h-10 border-4 border-primary/30 border-t-primary rounded-full animate-spin" />
            </div>
        );
    }

    if (!isAuthenticated || !user) {
        // Not logged in? Show the children (usually CustomerApp)
        return <>{children}</>;
    }

    // Authenticated? Redirect to role-based dashboard
    switch (user.role) {
        case 'SUPER_ADMIN':
        case 'DATA_AUDITOR':
            return <Navigate to="/admin" replace />;
        case 'BRANCH_MANAGER':
            return <Navigate to="/manager" replace />;
        case 'WAITER':
            return <Navigate to="/waiter" replace />;
        case 'CASHIER':
            return <Navigate to="/cashier" replace />;
        case 'RECEPTIONIST':
            return <Navigate to="/receptionist" replace />;
        default:
            // Unknown role? Just show children (might be a specific customer role in future)
            return <>{children}</>;
    }
};
